export enum HotelMode {
  TASK_BASED = "T",
  ROOMSTATE_BASED = "R"
}